import React from 'react';
import { createSubcomponent, styled } from '@workday/canvas-kit-react/common';
import { Box } from '@workday/canvas-kit-react/layout';
import { OverflowTooltip } from '@workday/canvas-kit-react/tooltip';
import { usePillModel } from './usePillModel';
import { colors } from '@workday/canvas-kit-react/tokens';
const StyledLabelContainer = styled(Box.as('span'))({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
});
export const PillLabel = createSubcomponent('span')({
    modelHook: usePillModel,
})(({ tooltipProps, ...elemProps }, Element, model) => {
    return (React.createElement(OverflowTooltip, Object.assign({}, tooltipProps),
        React.createElement(StyledLabelContainer, Object.assign({ color: model.state.disabled ? colors.licorice100 : 'inherit', maxWidth: model.state.maxWidth, as: Element, id: `label-${model.state.id}` }, elemProps), elemProps.children)));
});
